import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgIf } from '@angular/common';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { IconSize } from '../../../../models/types/icon-size.type';

@Component({
  selector: 'jhi-bary-icon',
  templateUrl: 'bary-icon.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MDBBootstrapModulesPro, NgIf],
})
export class BaryIconComponent {
  @Input() public icon!: string;
  @Input() public faDirective: FaDirectiveEnum = FaDirectiveEnum.FAS;
  @Input() public title: string = '';
  @Input() public size: IconSize = 'md';
  @Input() public class: string = '';

  protected readonly FaDirectiveEnum: typeof FaDirectiveEnum = FaDirectiveEnum;
}
